// extracted by mini-css-extract-plugin
export var pillWrapper = "_ou-0";
export var showOverflow = "_ou-1";